import React, { Component } from 'react'
import './_styles.scss'
import Asset from '../../../../requests/apa/Asset'
import { getNodeHeaderImage } from '../../../../utils/Utils'
import { getPhase2Config } from '../../utils'

class BrandHeader extends Component { 
    constructor (props) {
        super(props)
        this.isPhase2Enabled = getPhase2Config()
    }
    
    render () {
        const url = getNodeHeaderImage(this.props.nodeCode, this.props.region)

        return (
            <div className={`brand-header ${this.isPhase2Enabled ? '' : 'brand-header__phase1'}`}>
                <div className='brand-header__container'>
                    <img src={url} alt="brandheader" />
                </div>
            </div>
        )
    }
}

export default BrandHeader


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Components/BrandHeader/index.jsx